<script setup lang="ts">
import { computed, ref } from "vue";
import { Facade } from "@/drawing";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

defineProps<{
  target: string;
}>();

const input = ref<string>("");

const value = computed(() => {
  if (!Facade.isInitialized) return "-";
  return Facade.photoMarkers.getSelectedAttributeValue() ?? "-";
});

function setValue() {
  if (input.value.trim() !== "" && Facade.isInitialized) {
    Facade.photoMarkers.setSelectedAttributeValue(input.value.trim());
  }
}
</script>

<template>
  <button
    type="button"
    class="canvas-btn canvas-btn-nosize dropdown-toggle scale-btn"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    #{{ value }}
  </button>
  <ul class="dropdown-menu canvas-dropdown">
    <li>
      <h6 class="dropdown-header">
        {{ $t("canvas:floating.photomarker.value.header") }}
      </h6>
    </li>
    <li>
      <div class="input-group p-1">
        <input
          type="text"
          class="form-control"
          v-model="input"
          :placeholder="value"
          style="width: 60px"
          @keydown.enter="setValue()"
        />
        <span type="button" class="input-group-text" @click="setValue()">
          <PhosphorIcon name="check" :size="14" />
        </span>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
// Toute la hauteur de la barre, comme les autres boutons.
.scale-btn {
  height: 36px;
  padding: 0 10px;
  gap: 4px;
}

.canvas-dropdown {
  background-color: var(--canvas-bg);
  border: 1px solid var(--canvas-border);
  color: white;

  .dropdown-header {
    color: rgba(255, 255, 255, 0.4);
  }

  .input-group-text {
    background-color: var(--canvas-bg-hover);
    border-color: var(--canvas-border);
    color: white;
    cursor: pointer;
    // Survol à la souris seulement (au doigt, :hover reste collé après l'appui).
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background-color: var(--canvas-btn-active-bg);
      }
    }
  }

  .form-control {
    background-color: var(--canvas-bg-hover);
    border-color: var(--canvas-border);
    color: white;
    &:focus {
      background-color: var(--canvas-bg-hover) !important;
      color: white !important;
      box-shadow: none;
      border-color: var(--canvas-border);
    }
  }
}
</style>
